import Image2 from '../apartment1/bedroom.webp'
import Image3 from '../apartment1/bedroom2.webp'
import Image4 from '../apartment1/bedroom3.webp'
import Image5 from '../apartment1/garden.webp'
import Image6 from '../apartment1/garden2.webp'
import Image7 from '../apartment1/hallway.webp'
import Image8 from '../apartment1/kitchen.webp'
import Image9 from '../apartment1/livingroom.webp'
import Image10 from '../apartment1/livingroom2.webp'
import Image11 from '../apartment1/outside.webp'
import Image12 from '../apartment1/outside2.webp'
import Image13 from '../apartment1/stairway.webp'

const ApartmentOneImages = [
    {
        id: 9,
        image: Image9,
    }, {
        id: 10,
        image: Image10,
    }, {
    id: 2,
    image: Image2,
  }, {
    id: 3,
    image: Image3,
  }, {
    id: 4,
    image: Image4,
  }, {
    id: 5,
    image: Image5,
  }, {
    id: 6,
    image: Image6,
  }, {
    id: 7,
    image: Image7,
  }, {
    id: 8,
    image: Image8,
  },{
    id: 11,
    image: Image11,
  }, {
    id: 12,
    image: Image12,
  }, {
    id: 13,
    image: Image13,
  }
]

export default ApartmentOneImages
